module.exports = __webpack_public_path__ + "static/media/icon-social-impressions.c0b9331f.svg";